import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useTranslation } from "react-i18next";

import { NotificationToast } from "../components/Generic/Toast/NotificationToast";
import { ChecklistSeal } from "../models/checklist.seal";
import ChecklistSealsService from "../services/checklist.seal.service";
import { checkError } from "../util/checkError";
import { ChecklistSealsKeys } from "../util/queries";

export const useChecklistSealsAction = () => {
  const { t: translate } = useTranslation();

  const { mutate: createCheckedCheckListSeals, isLoading: isCheckListSealsLoading } = useMutation(
    [ChecklistSealsKeys.createChecked],
    async (data: ChecklistSeal) => {
      const response = await ChecklistSealsService.baseCreate(data);

      return response.data;
    },
    {
      onError: (error: AxiosError<Error>) => {
        checkError(error, translate("anErrorOccurredTryAgain"));
      },
      onSuccess: (response) => {
        if (response) NotificationToast.success(translate("operationPerformedSuccessfully"));
      },
    }
  );

  const createCheckedChecklistSeals = (
    data: ChecklistSeal,
    callback: (data: ChecklistSeal) => void
  ) => {
    return createCheckedCheckListSeals(data, {
      onSuccess: (data) => {
        callback(data);
      },
    });
  };

  return {
    isCheckListSealsLoading,
    createCheckedChecklistSeals,
  };
};
